import { Result } from 'antd';
import { useNavigate } from 'react-router';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';

export const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleBackHome = () => navigate('/');

  return (
    <Result
      status='404'
      subTitle='Sorry, the page you visited does not exist.'
      title='404'
      extra={
        <Button type={ButtonTypeEnum.Primary} onClick={handleBackHome}>
          Back Home
        </Button>
      }
    />
  );
};
